<template>
    <el-dialog v-bind="$attrs" :visible.sync="innerVisible" :close-on-click-modal="false" :before-close="handleClose">
        <slot></slot>
        <span v-if="showCancelConfirm" slot="footer" class="cancel-confirm">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: { type: Boolean, default: false },
        showCancelConfirm: { type: Boolean, default: false }
    },
    data() {
        return {
            innerVisible: this.visible
        };
    },
    watch: {
        visible(val) { this.innerVisible = val; }
    },
    methods: {
        handleClose() {
            this.$emit('update:visible', false);
        },
        handleCancel() {
            this.$emit('cancel');
            this.handleClose();
        },
        handleConfirm() {
            this.$emit('confirm');
        }
    }
};
</script>

<style lang="less" scoped>
:deep(.el-dialog__body) {
    // padding-top: 0;
}

:deep(.el-dialog__headerbtn) .el-dialog__close {
    &:hover {
        color: #1677ff;
    }
}
</style>